const initialContext = {
  brandAssetsURL: null,
  talkdeskIdAssetsURL: null,
  csrfToken: null,
  tenantId: '',
  splitIoKeyUI: '',
  passwordPolicies: null,
  showGoogleFooterLink: true,
}

const branding = document.brandingSettings || {}

const context = document.context || initialContext

export default {
  ...context,
  ...branding,
}
